import { render } from "./Logo.vue?vue&type=template&id=35770f25&scoped=true&ts=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=35770f25&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35770f25"]])

export default __exports__